module.exports = __webpack_public_path__ + "img/econsenso.afe3c3da.png";